import { InjectionToken } from '@angular/core';

export const S3_STORAGE_BASE_URL = new InjectionToken<string>('S3_STORAGE_BASE_URL');
